import { render, staticRenderFns } from "./privacy-policy.html?vue&type=template&id=644e1ae0&scoped=true&external"
import script from "./privacy-policy.js?vue&type=script&lang=js&external"
export * from "./privacy-policy.js?vue&type=script&lang=js&external"
import style0 from "./privacy-policy.scss?vue&type=style&index=0&id=644e1ae0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644e1ae0",
  null
  
)

export default component.exports